// extracted by mini-css-extract-plugin
export default {"menuButton":"index_menuButton__obN3Q"};